import { render, staticRenderFns } from "./Backups.vue?vue&type=template&id=7817c514&scoped=true"
import script from "./Backups.vue?vue&type=script&lang=js"
export * from "./Backups.vue?vue&type=script&lang=js"
import style0 from "./Backups.vue?vue&type=style&index=0&id=7817c514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7817c514",
  null
  
)

export default component.exports